// import React, { useState, useEffect, useRef } from "react";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import moment from "moment";
// import { Button, Form, InputGroup, Spinner } from "react-bootstrap";

// const LeadChat = ({ leadId, title, user, type, onClose }) => {
//     const [messages, setMessages] = useState([]);
//     const [newMessage, setNewMessage] = useState("");
//     const [loading, setLoading] = useState(false);
//     const scrollRef = useRef(null);

//     const currentSenderType = type; // "AGENT"

//     const fetchChat = async () => {
//         try {
//             const res = await apiService.getAll(`${config.GET_LEAD_CHAT}/${leadId}`);
//             if (res?.messages) setMessages(res.messages);
//         } catch (err) { console.error("Chat error", err); }
//     };

//     useEffect(() => { 
//         if (leadId) {
//             fetchChat();
//             // Optional: Set interval for auto-refresh every 10 seconds
//             const interval = setInterval(fetchChat, 10000);
//             return () => clearInterval(interval);
//         }
//     }, [leadId]);

//     useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

//     const handleSendMessage = async (e) => {
//         e.preventDefault();
//         if (!newMessage.trim()) return;

//         setLoading(true);
//         const payload = {
//             senderId: user.id,
//             senderName: user.name,
//             senderType: currentSenderType,
//             content: newMessage,
//             attachments: []
//         };

//         try {
//             await apiService.create(`${config.SEND_LEAD_CHAT_MESSAGE}/${leadId}`, payload);
//             setNewMessage("");
//             fetchChat();
//         } catch (err) { console.error("Send error", err); } 
//         finally { setLoading(false); }
//     };

//     return (
//         <div className="d-flex flex-column h-100 bg-white shadow-none" style={{ position: 'relative' }}>
            
//             {/* --- PREMIUM HEADER --- */}
//             <div className="p-3 border-bottom bg-light d-flex justify-content-between align-items-center">
//                 <div className="d-flex align-items-center">
//                     <div className="avatar-xs bg-primary rounded-circle d-flex align-items-center justify-content-center me-2 text-white small fw-bold">
//                         {title?.charAt(0)}
//                     </div>
//                     <div>
//                         <h6 className="mb-0 fw-bold text-dark" style={{ fontSize: '14px' }}>{title}</h6>
//                         <small className="text-success small" style={{ fontSize: '10px' }}>
//                             <i className="ri-record-circle-fill me-1"></i> Active Channel
//                         </small>
//                     </div>
//                 </div>
//                 {/* CLOSE BUTTON - Fixed visibility */}
//                 <Button 
//                     variant="soft-danger" 
//                     size="sm" 
//                     className="rounded-pill px-3 fw-bold" 
//                     onClick={onClose}
//                     style={{ fontSize: '11px' }}
//                 >
//                     <i className="ri-close-line me-1"></i> Close Chat
//                 </Button>
//             </div>

//             {/* --- MESSAGES BODY --- */}
//             <div className="p-3 overflow-auto flex-grow-1" style={{ backgroundColor: "#f8f9fa", backgroundImage: "url('https://www.transparenttextures.com/patterns/cubes.png')" }}>
//                 {messages.length > 0 ? messages.map((msg, i) => {
//                     const isMe = msg.senderType === currentSenderType;
//                     return (
//                         <div key={i} className={`d-flex mb-3 ${isMe ? "justify-content-end" : "justify-content-start"}`}>
//                             <div className={`shadow-sm p-2 px-3 ${isMe ? "bg-primary text-white rounded-start-lg rounded-top-lg" : "bg-white text-dark rounded-end-lg rounded-top-lg border"}`} 
//                                  style={{ 
//                                      maxWidth: "75%", 
//                                      borderRadius: isMe ? "15px 15px 0 15px" : "15px 15px 15px 0",
//                                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
//                                  }}>
//                                 <div className="d-flex justify-content-between align-items-center mb-1 gap-4">
//                                     <span className="fw-bold" style={{ fontSize: '10px', opacity: isMe ? 0.9 : 0.7 }}>
//                                         {isMe ? "You" : msg.senderName}
//                                     </span>
//                                     <span style={{ fontSize: '9px', opacity: 0.6 }}>
//                                         {moment(msg.sentAt).format("hh:mm A")}
//                                     </span>
//                                 </div>
//                                 <div style={{ fontSize: '13px', lineHeight: '1.4' }}>{msg.content}</div>
//                             </div>
//                         </div>
//                     );
//                 }) : (
//                     <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted opacity-50">
//                         <i className="ri-chat-smile-2-line display-4"></i>
//                         <p className="small mt-2">No messages yet. Send a message to start negotiating.</p>
//                     </div>
//                 )}
//                 <div ref={scrollRef} />
//             </div>

//             {/* --- INPUT FOOTER --- */}
//             <div className="p-3 bg-white border-top">
//                 <Form onSubmit={handleSendMessage}>
//                     <InputGroup className="bg-light rounded-pill p-1 border">
//                         <Button variant="link" className="text-muted border-0 shadow-none"><i className="ri-attachment-2 fs-18"></i></Button>
//                         <Form.Control 
//                             className="bg-transparent border-0 shadow-none py-2" 
//                             placeholder="Type your message..." 
//                             value={newMessage} 
//                             onChange={(e) => setNewMessage(e.target.value)} 
//                             disabled={loading}
//                             style={{ fontSize: '14px' }}
//                         />
//                         <Button 
//                             variant="primary" 
//                             type="submit" 
//                             className="rounded-circle avatar-xs p-0 d-flex align-items-center justify-content-center shadow-sm"
//                             disabled={loading || !newMessage.trim()}
//                         >
//                             {loading ? <Spinner animation="border" size="sm" /> : <i className="ri-send-plane-2-fill fs-16"></i>}
//                         </Button>
//                     </InputGroup>
//                 </Form>
//             </div>
//         </div>
//     );
// };

// export default LeadChat;

import React, { useState, useEffect, useRef } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import moment from "moment";
import { Button, Form, InputGroup, Spinner, Badge } from "react-bootstrap";

const LeadChat = ({ leadId, title, user, type, onClose }) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]); // File state
    const [loading, setLoading] = useState(false);
    const scrollRef = useRef(null);
    const fileInputRef = useRef(null);

    const currentSenderType = type;

    const fetchChat = async () => {
        try {
            const res = await apiService.getAll(`${config.GET_LEAD_CHAT}/${leadId}`);
            if (res?.messages) setMessages(res.messages);
        } catch (err) { console.error("Chat error", err); }
    };

    useEffect(() => { 
        if (leadId) {
            fetchChat();
            const interval = setInterval(fetchChat, 10000);
            return () => clearInterval(interval);
        }
    }, [leadId]);

    useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!newMessage.trim() && selectedFiles.length === 0) return;

        setLoading(true);
        
        // --- USE FORMDATA FOR FILES ---
        const formData = new FormData();
        formData.append("content", newMessage);
        formData.append("senderId", user.id);
        formData.append("senderName", user.name);
        formData.append("senderType", currentSenderType);
        
        selectedFiles.forEach(file => {
            formData.append("files", file);
        });

        try {
            // Must use postWithFile or similar for multipart
            await apiService.postWithFile(`${config.SEND_LEAD_CHAT_MESSAGE}/${leadId}`, formData);
            setNewMessage("");
            setSelectedFiles([]); // Clear files
            fetchChat();
        } catch (err) { console.error("Send error", err); } 
        finally { setLoading(false); }
    };

    return (
        <div className="d-flex flex-column h-100 bg-white shadow-none border">
            {/* Header (Same as your previous version) */}
            <div className="p-3 border-bottom bg-light d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <div className="avatar-xs bg-primary rounded-circle d-flex align-items-center justify-content-center me-2 text-white small fw-bold">{title?.charAt(0)}</div>
                    <h6 className="mb-0 fw-bold text-dark">{title}</h6>
                </div>
                <Button variant="soft-danger" size="sm" className="rounded-pill px-3 fw-bold" onClick={onClose}>Close Chat</Button>
            </div>

            {/* Messages Body */}
            <div className="p-3 overflow-auto flex-grow-1 bg-light">
                {messages.map((msg, i) => {
                    const isMe = msg.senderType === currentSenderType;
                    return (
                        <div key={i} className={`d-flex mb-3 ${isMe ? "justify-content-end" : "justify-content-start"}`}>
                            <div className={`shadow-sm p-2 px-3 ${isMe ? "bg-primary text-white" : "bg-white text-dark border"}`} 
                                 style={{ maxWidth: "75%", borderRadius: isMe ? "15px 15px 0 15px" : "15px 15px 15px 0" }}>
                                <div className="d-flex justify-content-between align-items-center mb-1 gap-4">
                                    <span className="fw-bold" style={{ fontSize: '10px' }}>{isMe ? "You" : msg.senderName}</span>
                                    <span style={{ fontSize: '9px', opacity: 0.6 }}>{moment(msg.sentAt).format("hh:mm A")}</span>
                                </div>
                                
                                {/* Content */}
                                <div style={{ fontSize: '13px' }}>{msg.content}</div>

                                {/* Attachments Rendering */}
                                {msg.attachments?.length > 0 && (
                                    <div className="mt-2 border-top pt-2">
                                        {msg.attachments.map((file, idx) => (
                                            <div key={idx} className="mb-1">
                                                {file.fileType.includes("image") ? (
                                                    <a href={file.url} target="_blank" rel="noreferrer">
                                                        <img src={file.url} alt="att" className="img-thumbnail mt-1" style={{ maxHeight: '150px' }} />
                                                    </a>
                                                ) : (
                                                    <a href={file.url} target="_blank" rel="noreferrer" className={isMe ? "text-white" : "text-primary"} style={{ fontSize: '11px', textDecoration: 'underline' }}>
                                                        <i className="ri-file-download-line me-1"></i> {file.fileName}
                                                    </a>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
                <div ref={scrollRef} />
            </div>

            {/* Footer with File Preview */}
            <div className="p-2 bg-white border-top">
                {selectedFiles.length > 0 && (
                    <div className="px-2 mb-2 vstack gap-1">
                        {selectedFiles.map((f, i) => (
                            <Badge key={i} bg="soft-primary" className="text-primary d-flex justify-content-between align-items-center p-2">
                                <span className="text-truncate" style={{maxWidth: '200px'}}>{f.name}</span>
                                <i className="ri-close-line cursor-pointer" onClick={() => setSelectedFiles(selectedFiles.filter((_, idx) => idx !== i))}></i>
                            </Badge>
                        ))}
                    </div>
                )}
                
                <Form onSubmit={handleSendMessage}>
                    <InputGroup className="bg-light rounded-pill p-1 border">
                        {/* Hidden File Input */}
                        <input 
                            type="file" 
                            multiple 
                            ref={fileInputRef} 
                            style={{ display: 'none' }} 
                            onChange={(e) => setSelectedFiles([...selectedFiles, ...Array.from(e.target.files)])} 
                        />
                        <Button variant="link" className="text-muted border-0 shadow-none" onClick={() => fileInputRef.current.click()}>
                            <i className="ri-attachment-2 fs-18"></i>
                        </Button>
                        <Form.Control 
                            className="bg-transparent border-0 shadow-none py-2" 
                            placeholder="Type message..." 
                            value={newMessage} 
                            onChange={(e) => setNewMessage(e.target.value)} 
                        />
                        <Button variant="primary" type="submit" className="rounded-circle avatar-xs p-0 shadow-sm" disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm" /> : <i className="ri-send-plane-2-fill fs-16"></i>}
                        </Button>
                    </InputGroup>
                </Form>
            </div>
        </div>
    );
};

export default LeadChat;